import { lastDayOfMonth, getDate, setDate } from 'date-fns'

export const createDatesOfMonth = (base: Date): Date[] =>
  Array.from(
    { length: getDate(lastDayOfMonth(base)) },
    (_, index) => index
  ).map(index => setDate(base, index + 1))
